import createAction from 'redux-actions/es/createAction';

import { FETCH_MERCHANT } from './consts/types';

export { findMerchantById } from '@esentai/core/features/merchants/actions';

export const fetchMerchant = createAction(FETCH_MERCHANT);
